import type { SVGProps } from 'react';

const SvgCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 16 16" {...props}>
    <path
      fill={props.color}
      d="M14.47 3.53c.26.26.26.68 0 .94l-8.51 8.51-4.47-5.21A.666.666 0 1 1 2.5 6.9l3.53 4.12 7.49-7.49c.26-.26.68-.26.94 0z"
    />
    <path
      fill={props.color}
      d="M5.93 13.72 1.11 8.1a1.2 1.2 0 0 1-.28-.85c.02-.31.17-.59.4-.79.49-.42 1.23-.36 1.64.12l3.18 3.71 7.11-7.11c.4-.4 1.02-.45 1.47-.15h.03l.16.15c.22.22.34.51.34.82s-.12.6-.34.82z"
    />
  </svg>
);

export default SvgCheck;
